import React from 'react';
import { Icon, Spin, StatusPill, InvPill, MarginChip, StatusDot,
         Drawer, Modal, Tabs, FG, RG } from '../components/ui.jsx';
import { api, fmt, fmtD, dayN } from '../api.js';
import { ROLES, RL, TIPOLOGIE, REGIE, STATUSES, SL, INVOICE, MAT_CAT, MONTHS,
         STATUS_COLORS, INV_COLORS } from '../constants.js';

export const AccountPage = ({onNav}) => {
  const now=new Date();
  const [year,setYear]=React.useState(now.getFullYear());
  const [month,setMonth]=React.useState(null);
  const [data,setData]=React.useState(null);
  const [loading,setLoading]=React.useState(false);

  const load=()=>{
    setLoading(true);
    const qs=month?`?year=${year}&month=${month}`:`?year=${year}`;
    api(`/dashboard/margin${qs}`).then(d=>{setData(d);setLoading(false);}).catch(()=>setLoading(false));
  };
  React.useEffect(()=>{load()},[year,month]);
  if(loading||!data)return<div className="empty"><Spin/> Caricamento...</div>;
  const {totals,by_client,by_month,by_technician,projects}=data;

  const goProject = (id) => onNav && onNav('projects', id);

  return(
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">Account Manager</div>
          <div className="page-title-sub">Marginalita e analisi economica</div>
        </div>
        <div style={{display:'flex',gap:8}}>
          <select className="input" style={{width:90}} value={year}
            onChange={e=>setYear(+e.target.value)}>
            {[2024,2025,2026,2027].map(y=><option key={y}>{y}</option>)}
          </select>
          <select className="input" style={{width:130}} value={month||''}
            onChange={e=>setMonth(e.target.value?+e.target.value:null)}>
            <option value="">Tutto l'anno</option>
            {MONTHS.slice(1).map((m,i)=><option key={i+1} value={i+1}>{m}</option>)}
          </select>
        </div>
      </div>

      {/* KPI marginalita */}
      <div className="kpi-row" style={{marginBottom:20}}>
        {[
          {label:'Revenue totale',val:fmt(totals.revenue),color:'#065F46',border:'#6EE7B7'},
          {label:'Costi crew',val:fmt(totals.crew_cost),color:'var(--n700)'},
          {label:'Spese operative',val:fmt(totals.spese_operative),color:'var(--n700)'},
          {label:'Margine netto',val:fmt(totals.margine_netto),
            color:totals.margine_netto>=0?'#065F46':'#991B1B',
            border:totals.margine_netto>=0?'#6EE7B7':'#FCA5A5'},
        ].map(k=>(
          <div key={k.label} className="kpi-card"
            style={k.border?{borderTop:`3px solid ${k.border}`}:{}}>
            <div className="kpi-val" style={{color:k.color,fontSize:'1.3rem'}}>{k.val}</div>
            <div className="kpi-lbl">{k.label}</div>
          </div>
        ))}
      </div>

      <div className="grid grid-2" style={{marginBottom:16}}>
        {/* Per cliente */}
        <div className="card">
          <div className="card-title"><Icon name="building" size={12} color="var(--n400)"/>Per cliente</div>
          <table>
            <thead><tr><th>Cliente</th><th style={{textAlign:'right'}}>Revenue</th>
              <th style={{textAlign:'right'}}>Costi</th><th style={{textAlign:'right'}}>Margine</th></tr></thead>
            <tbody>
              {by_client.sort((a,b)=>b.revenue-a.revenue).map(c=>(
                <tr key={c.client} style={{cursor:'pointer'}}
                  onClick={()=>onNav&&onNav('clients')}>
                  <td style={{fontWeight:600,fontSize:13}}>{c.client}</td>
                  <td style={{textAlign:'right',fontWeight:600,color:'#065F46',fontSize:12}}>{fmt(c.revenue)}</td>
                  <td style={{textAlign:'right',color:'var(--n400)',fontSize:12}}>{fmt(c.costo_totale)}</td>
                  <td style={{textAlign:'right',fontWeight:700,fontSize:12,
                    color:c.margine_netto>=0?'#065F46':'#991B1B'}}>{fmt(c.margine_netto)}</td>
                </tr>
              ))}
              {!by_client.length&&<tr><td colSpan={4} className="empty" style={{padding:16}}>Nessun dato</td></tr>}
            </tbody>
          </table>
        </div>

        {/* Per tecnico */}
        <div className="card">
          <div className="card-title"><Icon name="users" size={12} color="var(--n400)"/>Costi per tecnico</div>
          <table>
            <thead><tr><th>Tecnico</th><th>Tipo</th>
              <th style={{textAlign:'right'}}>Cantieri</th><th style={{textAlign:'right'}}>Costo</th></tr></thead>
            <tbody>
              {by_technician.map(t=>(
                <tr key={t.name} style={{cursor:'pointer'}}
                  onClick={()=>onNav&&onNav('techs')}>
                  <td style={{fontWeight:600,fontSize:13}}>{t.name}</td>
                  <td><span className={`emp-badge emp-${t.employment_type||'freelance'}`}>{t.employment_type}</span></td>
                  <td style={{textAlign:'right',color:'var(--n400)',fontSize:12}}>{t.cantieri}</td>
                  <td style={{textAlign:'right',fontWeight:600,color:'#B87D00',fontSize:12}}>{fmt(t.costo_totale)}</td>
                </tr>
              ))}
              {!by_technician.length&&<tr><td colSpan={4} className="empty" style={{padding:16}}>Nessun dato</td></tr>}
            </tbody>
          </table>
        </div>
      </div>

      {/* Andamento mensile */}
      {!month&&by_month.length>0&&(
        <div className="card" style={{marginBottom:16}}>
          <div className="card-title"><Icon name="trending-up" size={12} color="var(--n400)"/>Andamento mensile {year}</div>
          <table>
            <thead><tr><th>Mese</th><th style={{textAlign:'right'}}>Revenue</th>
              <th style={{textAlign:'right'}}>Costi</th><th style={{textAlign:'right'}}>Margine</th></tr></thead>
            <tbody>
              {by_month.map(m=>{
                const mn=+(m.margine||0);
                return(
                  <tr key={m.month} style={{cursor:'pointer'}}
                    onClick={()=>setMonth(m.month)}>
                    <td style={{fontWeight:600,fontSize:13}}>{MONTHS[m.month]}</td>
                    <td style={{textAlign:'right',fontWeight:600,color:'#065F46',fontSize:12}}>{fmt(m.revenue)}</td>
                    <td style={{textAlign:'right',color:'var(--n400)',fontSize:12}}>{fmt(m.costi)}</td>
                    <td style={{textAlign:'right',fontWeight:700,fontSize:12,
                      color:mn>=0?'#065F46':'#991B1B'}}>{fmt(mn)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {/* Tabella cantieri */}
      <div className="card" style={{padding:0}}>
        <div style={{padding:'14px 20px 10px',display:'flex',alignItems:'center',gap:6}}>
          <div className="card-title" style={{margin:0}}>
            <Icon name="clapperboard" size={12} color="var(--n400)"/>
            Cantieri nel periodo ({projects.length})
          </div>
        </div>
        <table>
          <thead><tr>
            <th>Codice</th><th>Cantiere</th><th>Cliente</th>
            <th style={{textAlign:'right'}}>Revenue</th>
            <th style={{textAlign:'right'}}>Costi</th>
            <th style={{textAlign:'right'}}>Margine</th>
            <th style={{textAlign:'right'}}>%</th>
            <th>Fattur.</th>
          </tr></thead>
          <tbody>
            {projects.map(p=>(
              <tr key={p.id} style={{cursor:'pointer'}} onClick={()=>goProject(p.id)}>
                <td style={{fontWeight:700,color:'var(--blue)',fontSize:12}}>{p.code}</td>
                <td style={{fontWeight:500,fontSize:13}}>{p.title}</td>
                <td style={{fontSize:12,color:'var(--n400)'}}>{p.client_name||'-'}</td>
                <td style={{textAlign:'right',fontWeight:600,color:'#065F46',fontSize:12}}>
                  {p.revenue>0?fmt(p.revenue):'-'}</td>
                <td style={{textAlign:'right',color:'var(--n400)',fontSize:12}}>{fmt(p.costo_totale)}</td>
                <td style={{textAlign:'right',fontWeight:700,fontSize:12,
                  color:p.margine_netto>=0?'#065F46':'#991B1B'}}>{fmt(p.margine_netto)}</td>
                <td style={{textAlign:'right'}}><MarginChip pct={p.margine_pct}/></td>
                <td><InvPill val={p.invoice_status}/></td>
              </tr>
            ))}
            {!projects.length&&<tr><td colSpan={8} className="empty" style={{padding:20}}>Nessun cantiere nel periodo</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
};
